import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const TrustServiceCriteriaFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.TRUST_SERVICE_CRITERIA}
        filterName={FilterName.TRUST_SERVICE_CRITERIA}
        valueKey="trustServiceCriteria"
        isNested={isNested}
      />
    )
  },
)
